// ----------------------------------------------------------------------------
//   Imports
// ----------------------------------------------------------------------------

// React
import { useState, useEffect } from 'react';

// Material UI
import {
  IconButton,
} from "@mui/material";


// ----------------------------------------------------------------------------
//   Main Component
// ----------------------------------------------------------------------------

function IconToggleButton({
  state,
  onToggle,
  iconActive,
  iconInactive = null,
  ...buttonProps
}) {
  return (
    <IconButton onClick={() => onToggle(!state)} {...buttonProps}>
      { state ? iconActive : (iconInactive ?? iconActive) }
    </IconButton>
  )
}


// ----------------------------------------------------------------------------
//   Export(s)
// ----------------------------------------------------------------------------

export default IconToggleButton;
